var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"l-section",style:(_vm.color ? ("--bg-color: var(--color-" + _vm.color + ")") : "")},[_c('div',{staticClass:"l-section__inner | grid"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }